// import React, { useState } from "react";
// import swal from "sweetalert";

// const AddRole = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     description: "",
//   });
//   const [loading, setLoading] = useState(false);

//   const API_BASE_URL = "http://127.0.0.1:5055";

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.name.trim()) {
//       swal("Error", "Role name is required", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await fetch(`${API_BASE_URL}/api/roles/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const data = await res.json();
//       if (!res.ok) throw new Error(data.error || "Failed to create role");

//       swal("Success", "Role created successfully!", "success");
//       setFormData({ name: "", description: "" }); // reset form
//     } catch (err) {
//       swal("Error", err.message, "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         maxWidth: "400px",
//         margin: "50px auto",
//         padding: "25px",
//         background: "#fff",
//         borderRadius: "12px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         fontFamily: "Arial, sans-serif",
//       }}
//     >
//       <h2
//         style={{
//           textAlign: "center",
//           marginBottom: "20px",
//           color: "#333",
//         }}
//       >
//         Add New Role
//       </h2>

//       <form onSubmit={handleSubmit}>
//         {/* Role Name */}
//         <div style={{ marginBottom: "15px" }}>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "6px",
//               fontWeight: "bold",
//               color: "#444",
//             }}
//           >
//             Role Name
//           </label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             placeholder="Enter role name"
//             style={{
//               width: "100%",
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "8px",
//               outline: "none",
//               transition: "0.3s",
//             }}
//           />
//         </div>

//         {/* Role Description */}
//         <div style={{ marginBottom: "15px" }}>
//           <label
//             style={{
//               display: "block",
//               marginBottom: "6px",
//               fontWeight: "bold",
//               color: "#444",
//             }}
//           >
//             Description
//           </label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             placeholder="Enter role description"
//             rows="3"
//             style={{
//               width: "100%",
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "8px",
//               outline: "none",
//               resize: "none",
//               transition: "0.3s",
//             }}
//           />
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={loading}
//           style={{
//             width: "100%",
//             padding: "12px",
//             background: loading ? "#95a5a6" : "#3498db",
//             color: "#fff",
//             border: "none",
//             borderRadius: "8px",
//             fontSize: "16px",
//             cursor: loading ? "not-allowed" : "pointer",
//             transition: "0.3s",
//           }}
//         >
//           {loading ? "Saving..." : "Create Role"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AddRole;



import React, { useState, useEffect } from "react";
import swal from "sweetalert";

const RolesPage = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [formData, setFormData] = useState({ name: "", description: "" });

  const API_BASE_URL = "https://dairy.server.statify.co.ke";

  /** ----------------- FETCH ROLES ----------------- **/
  const fetchRoles = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/roles/`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to fetch roles");
      setRoles(Array.isArray(data) ? data : []);
    } catch (err) {
      swal("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  /** ----------------- FORM HANDLERS ----------------- **/
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const openDrawer = (role = null) => {
    if (role) {
      setEditingRole(role);
      setFormData({ name: role.name, description: role.description || "" });
    } else {
      setEditingRole(null);
      setFormData({ name: "", description: "" });
    }
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setFormData({ name: "", description: "" });
    setEditingRole(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      swal("Error", "Role name is required", "error");
      return;
    }

    try {
      const url = editingRole
        ? `${API_BASE_URL}/api/roles/${editingRole.id}`
        : `${API_BASE_URL}/api/roles/`;
      const method = editingRole ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to save role");

      swal("Success", editingRole ? "Role updated!" : "Role created!", "success");
      closeDrawer();
      fetchRoles();
    } catch (err) {
      swal("Error", err.message, "error");
    }
  };

  const handleDelete = async (roleId) => {
    const confirm = await swal({
      title: "Delete Role?",
      text: "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/roles/${roleId}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to delete role");

      swal("Deleted!", "Role removed successfully", "success");
      fetchRoles();
    } catch (err) {
      swal("Error", err.message, "error");
    }
  };

  /** ----------------- UI ----------------- **/
  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        position: "relative",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ margin: 0, color: "#333" }}>Role Management</h2>
        <button
          onClick={() => openDrawer()}
          style={{
            background: "#3498db",
            color: "#fff",
            border: "none",
            padding: "10px 16px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          + Add Role
        </button>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : roles.length === 0 ? (
        <p>No roles found.</p>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <thead>
            <tr style={{ background: "#f4f6f8" }}>
              <th style={{ padding: "12px", textAlign: "left" }}>ID</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Name</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Description</th>
              <th style={{ padding: "12px", textAlign: "left" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role) => (
              <tr key={role.id} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "12px" }}>{role.id}</td>
                <td style={{ padding: "12px" }}>{role.name}</td>
                <td style={{ padding: "12px" }}>{role.description || "—"}</td>
                <td style={{ padding: "12px" }}>
                  <button
                    onClick={() => openDrawer(role)}
                    style={{
                      marginRight: "10px",
                      background: "#f39c12",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(role.id)}
                    style={{
                      background: "#e74c3c",
                      color: "#fff",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Drawer */}
      {drawerOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            width: "350px",
            height: "100%",
            background: "#fff",
            boxShadow: "-2px 0 8px rgba(0,0,0,0.2)",
            padding: "20px",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h3 style={{ marginBottom: "20px", color: "#333" }}>
            {editingRole ? "Edit Role" : "Add Role"}
          </h3>
          <form onSubmit={handleSubmit} style={{ flex: 1 }}>
            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  fontWeight: "bold",
                }}
              >
                Role Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter role name"
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  fontWeight: "bold",
                }}
              >
                Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter role description"
                rows="3"
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  resize: "none",
                }}
              />
            </div>

            <div
              style={{
                marginTop: "auto",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <button
                type="button"
                onClick={closeDrawer}
                style={{
                  background: "#95a5a6",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                style={{
                  background: "#3498db",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                {editingRole ? "Update Role" : "Create Role"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default RolesPage;
